export default __webpack_public_path__ + "static/Toyota_Desktop_Typography_Legal_Weight-a4f5f3ebd21b4e81675a2ee11c9c2b10.svg";